import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { Button, BrandMark } from '../ui';

// Sticky marketing nav. IA: Features · District Demos · For Districts · Login · [Request Demo]
const MarketingNav = ({ onRequestDemo }) => {
  const [open, setOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const loggedIn = isAuthenticated && isAuthenticated.authenticated;

  const links = [
    { label: 'Features', href: '/#features' },
    { label: 'District Demos', to: '/demo' },
    { label: 'For Districts', href: '/#for-districts' },
    { label: 'Find Tickets', href: '/#find-tickets' },
  ];

  const NavLinks = ({ onClick }) => (
    <>
      {links.map((l) => l.to ? (
        <Link key={l.label} to={l.to} onClick={onClick} className="hover:text-white transition-colors">{l.label}</Link>
      ) : (
        <a key={l.label} href={l.href} onClick={onClick} className="hover:text-white transition-colors">{l.label}</a>
      ))}
    </>
  );

  return (
    <header className="sticky top-0 z-50 bg-brand-900/80 backdrop-blur border-b border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" onClick={() => setOpen(false)}>
          <BrandMark layout="horizontal" className="h-7 sm:h-8 text-white" />
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm text-white/85">
          <NavLinks />
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {loggedIn ? (
            <Button to={isAuthenticated.role === 'vendor' ? '/vendor-dashboard' : '/account'} variant="white" size="sm">
              {isAuthenticated.role === 'vendor' ? 'Dashboard' : 'My account'}
            </Button>
          ) : (
            <>
              <Link to="/login" className="text-sm text-white/85 hover:text-white transition-colors">Login</Link>
              <Button onClick={onRequestDemo} variant="accent" size="sm">Request Demo</Button>
            </>
          )}
        </div>

        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={open ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
          </svg>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-brand-900 border-t border-white/10 px-4 py-4 space-y-3 text-white/90">
          <div className="flex flex-col gap-3">
            <NavLinks onClick={() => setOpen(false)} />
          </div>
          <div className="pt-2 flex gap-3">
            <Button to="/login" variant="secondary" size="sm" className="flex-1" onClick={() => setOpen(false)}>Login</Button>
            <Button onClick={() => { setOpen(false); onRequestDemo && onRequestDemo(); }} variant="accent" size="sm" className="flex-1">Request Demo</Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default MarketingNav;
